import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useMemo, useState } from "react";
import {
    Chart as ChartJS,
    RadialLinearScale,
    ArcElement,
    Tooltip,
} from "chart.js";
import { PolarArea } from "react-chartjs-2";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import axios from "axios";

ChartJS.register(RadialLinearScale, ArcElement, Tooltip);

const COLORS = [
    "rgba(54, 162, 235, 0.6)",
    "rgba(255, 99, 132, 0.6)",
    "rgba(255, 206, 86, 0.6)",
    "rgba(75, 192, 192, 0.6)",
    "rgba(153, 102, 255, 0.6)",
    "rgba(255, 159, 64, 0.6)",
    "rgba(199, 199, 199, 0.6)",
    "rgba(83, 102, 255, 0.6)",
    "rgba(255, 99, 255, 0.6)",
];

const options = {
    responsive: true,
    plugins: {
        legend: { display: false },
        title: {
            display: true,
            text: "Top Categories",
            font: { size: 18, weight: "bold" },
            color: "#222",
            padding: { bottom: 20 },
        },
        tooltip: {
            callbacks: {
                label: (ctx) => `${ctx.label}`,
            },
        },
    },
    scales: {
        r: {
            ticks: { display: false },
            grid: { color: "rgba(0,0,0,0.05)" },
        },
    },
};

export default function TopCategory() {
    const [categories, setCategories] = useState([]);
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const url = API_BASE_URL;
    const token = decryptToken("accessToken") || "";
    const [equipment, setEquipment] = useState([])

    useEffect(() => {
        async function fetchCategories() {
            try {
                const res = await fetch(
                    `${url}/category/getdata/category/${userData.main_id}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const data = await res.json();

                const sorted = Array.isArray(data)
                    ? data
                        .filter((c) => c.status === "Active")
                        .sort((a, b) => Number(a.position) - Number(b.position))
                    : [];

                setCategories(sorted);
            } catch (err) {
                console.error("Category fetch failed:", err);
            }
        }

        fetchCategories();
    }, []);

    const fetchData = async () => {
        // setLoad(true);
        try {
            const response = await axios.get(`${url}/grouped-product/search-all-products/${userData.main_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { includeInactive: true },
            });

            const cleanedProducts = response.data.map((product) => {
                // Parse fields that are JSON strings
                const parsedProduct = {
                    ...product,
                    gallery: typeof product.gallery === "string" ? JSON.parse(product.gallery) : product.gallery,
                    key_features: typeof product.key_features === "string" ? JSON.parse(product.key_features) : product.key_features,
                    specifications: typeof product.specifications === "string" ? JSON.parse(product.specifications) : product.specifications,
                    // attribute: typeof product.attribute === "string" ? JSON.parse(product.attribute) : product.attribute,
                };

                // Handle variation only for Variable Product
                // if (product.product_type === "Variable Product" && typeof product.variation === "string") {
                //     // parsedProduct.variation = JSON.parse(product.variation);
                //     parsedProduct.variationPrices = parsedProduct.variation.map(v => v.salePrice || v.price);
                // }

                return parsedProduct;
            });


            // ✅ Save full product list as stringified JSON in localStorage
            // localStorage.setItem("equipmentsData", JSON.stringify(cleanedProducts));

            // ✅ Update state
            setEquipment(cleanedProducts.reverse());
        } catch (error) {
            console.error("Error fetching or parsing product data:", error);
            toast.error("Failed to fetch product data.");
        } finally {
            // setLoad(false)
        }
    };

    console.log(equipment)

    useEffect(() => {
        fetchData();
    }, [])

    // ✅ Build chart data from API categories
    const chartData = useMemo(() => {
        return {
            labels: categories.map((c) => c.category.trim()),
            datasets: [
                {
                    // Temporary value → position (replace with sales later)
                    data: categories.map((c) => Number(c.position) || 1),
                    backgroundColor: categories.map(
                        (_, i) => COLORS[i % COLORS.length]
                    ),
                    borderWidth: 1,
                },
            ],
        };
    }, [categories]);

    if (!categories.length) {
        return (
            <div className="flex items-center justify-center min-h-[300px] text-gray-500">
                No categories found
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center gap-4 min-h-[400px]">
            <PolarArea data={chartData} options={options} />
        </div>
    );
}
